module.exports = __webpack_public_path__ + "img/add-circle.8698cd8f.svg";